// extracted by mini-css-extract-plugin
module.exports = {"container":"NewSelectFilter_container__2iqq0","title":"NewSelectFilter_title__1ULvJ"};